

class Base {
  id() {
    return null;
  }

  renderElement(element) {
    return null;
  }
}


export default Base;
